import { render, staticRenderFns } from "./releaseNote.vue?vue&type=template&id=1bd5abb7&scoped=true&"
import script from "./releaseNote.vue?vue&type=script&lang=js&"
export * from "./releaseNote.vue?vue&type=script&lang=js&"
import style0 from "./releaseNote.vue?vue&type=style&index=0&id=1bd5abb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5abb7",
  null
  
)

export default component.exports